import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from './mutations';
import { state, SuccessToasterState } from './state';
import { getters } from '@/modules/SuccessToaster/store/getters';

const module: Module<SuccessToasterState, RootState> = {
    namespaced: true,
    state,
    mutations,
    getters
};

export default module;
export type {SuccessToasterState};
